import React, { Fragment, useState } from 'react'
import toast from 'react-hot-toast'

import ConfirmationModal from 'Design/components/ConfirmationModal'

import { useDisableAppMutation } from './happyfox-workflows.service'
import UnInstallApp from '../../../components/UnInstallApp'

const UnInstallHappyFoxWorkflows = () => {
  const [disableApp, disableAppResult] = useDisableAppMutation()

  const [showUninstallModal, setShowUninstallModal] = useState(false)

  const handleDisableApp = () => {
    const promise = disableApp().unwrap()

    toast.promise(promise, {
      loading: `Uninstalling HappyFox Workflow`,
      success: `HappyFox Workflow integration uninstalled successfully`,
      error: `Unable to uninstall HappyFox Workflow. Try again`
    })

    promise.then(handleCloseModal)
  }

  const handleCloseModal = () => {
    setShowUninstallModal(false)
  }

  const handleOpenModal = () => {
    setShowUninstallModal(true)
  }

  const isLoading = disableAppResult.isLoading

  return (
    <Fragment>
      <ConfirmationModal
        isOpen={showUninstallModal}
        title='Uninstall HappyFox Workflow'
        description='Are you sure to disable HappyFox Workflow integration?'
        onCloseButtonClick={handleCloseModal}
        onConfirmButtonClick={handleDisableApp}
        confirmButtonText='Yes'
        cancelButtonText='No'
        disableConfirmButton={isLoading}
      />
      <UnInstallApp onUninstall={handleOpenModal} isLoading={isLoading} />
    </Fragment>
  )
}

export default UnInstallHappyFoxWorkflows
